/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".legendWideControlGroup{margin:0 0 5px}.legendWideControlGroup label{margin-top:4px;font-weight:700}span.zero-hundred{position:relative;top:4px;margin-left:14px}.symbol-editor label{margin-bottom:8px}"];
export { styles as styles };
